import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { UseQueryResult } from "react-query";
import styled from "styled-components";
import { Flex } from "../layout";
import { Spinner } from "./icon";

type ResourceProps<T, K> = {
  r: UseQueryResult<T, K>;
  children: (x: T, r: UseQueryResult<T, K>) => JSX.Element;
};

export function Resource<T, K>({ r, children }: ResourceProps<T, K>) {
  return useMemo(() => {
    if (r.isLoading)
      return (
        <Wrapper2>
          <Spinner />
        </Wrapper2>
      );
    if (r.data) return children(r.data, r);
    if (r.error) return <AnErrorHasOccured />;
    return null;
  }, [r.data, r.isLoading, r.error]);
}

export const AnErrorHasOccured = () => {
  const { t } = useTranslation("commom");
  return (
    <Flex center>
      <Wrapper>
        <p>{t("error-has-occured")}</p>
      </Wrapper>
    </Flex>
  );
};

const Wrapper = styled.div`
  text-align: center;
  margin-top: 4em;
`;

const Wrapper2 = styled(Flex).attrs({ centered: true })`
  justify-content: center;
  height: 20em;
`;
